<template>
  <v-menu offset-y :attach="attach">
    <template #activator="{ on }">
      <v-btn icon color="primary" class="text-none" v-on="on">
        <v-icon color="primary" size="30"> mdi-dots-horizontal </v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <slot />
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'AppActionsMenu',

  props: {
    attach: {
      type: [Boolean, String],
      default: undefined,
    },
  },
}
</script>
